// 환경에 따라 자동으로 설정
// export const API_BASE_URL = process.env.NODE_ENV === 'production' 
//   ? '/api'  // 배포용 (yarn build)
//   //: 'http://usg.kr:4980/api';  // 로컬용 (yarn start)
//   : 'http://localhost:18080/api';  // 로컬용 (yarn start)

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL
export const MEDIA_SRC_BASE_URL = '/media/files'
